import { Err, ResponseData } from 'types';

import { http } from '.';

export const getExchangeRate = async (currency) => {
  return await http.get<Err, ResponseData<any>>(`/Currencies/${currency}/cbar`);
};

export const getTimezones = async () => {
  return await http.get<Err, ResponseData<any>>(`/Accounts/GetTimezones`);
};

export const getPaymentMethods = async () => {
  return await http.get<Err, ResponseData<any>>(`/PaymentMethod`);
};
export const getBankDatas = async () => {
  return await http.get<Err, ResponseData<any>>(
    `/BankDatas/GetMyBankShortDatas`
  );
};

export const setCulture = async (lang) => {
  return await http.post<Err, any>('Culture', null, {
    params: {
      culture: lang,
    },
  });
};

export const getInvoiceLang = async () => {
  return await http.get<Err, ResponseData<any>>(
    `/Accounts/GetInvoiceDefaultLanguage`
  );
};
